import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsArrayModel } from "src/app/models/widgets/widgets-array.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";

@Injectable()
export class CommandArrayService extends CommandAction {

    public execute(parent:WidgetsAbstract, widget: WidgetsAbstract): WidgetsArrayModel {
        const newArray = new WidgetsArrayModel();
        newArray.parentId = parent.id;
        return newArray;     
    }
}
